import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { ButtonComponent } from 'src/app/component/button/button.component';

@Component({
  selector: 'app-navbar',
  imports: [ButtonComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  isFlyoutOpen = false;
  @Output() buttonClickEvent: any = new EventEmitter();
  
  buttonClicked(event: any, elementId: string): void {
    console.log("button clicked");
    this.isFlyoutOpen = !this.isFlyoutOpen;
    document.getElementById(elementId)?.classList.toggle('hidden');
    console.log(elementId);
    console.log(document.getElementById(elementId))
    this.buttonClickEvent.emit(event);
  }

  navClickedOutside(event: any, elementId: string): void {
    console.log("nav clicked outside");
    this.isFlyoutOpen = false;
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.isFlyoutOpen = false;
  }
}
